import { useState, useRef, useEffect, useLayoutEffect, useCallback } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  MdHome,
  MdKeyboardArrowDown,
  MdKeyboardArrowRight,
  MdKeyboardArrowLeft,
  MdOutlineCalendarMonth,
  MdOutlineCameraAlt,
  MdPersonOutline,
  MdLogout,
  MdMenu,
  MdNotificationsNone,
  MdWork,
  MdInfo,
  MdSearch,
  MdClose,
} from "react-icons/md";
import { Tooltip } from "@mui/material";
import LibraryAddCheckIcon from "@mui/icons-material/LibraryAddCheck";
import { hasAccessToModule } from "./Pages/rbac/hasAccess";
import logo from "./image/DYC Retouched.png";
import MarkAttendanceModal from "./Pages/markAttendance/markAttendanceModal ";
import FloatingNav, { getVisibleChildren, isItemActive } from "./FloatingNav";

const mainMenuItems = [
  {
    label: "Masters",
    moduleAccessId: 1,
    children: [
      { moduleAccessId: 11, label: "Inspection Items", to: "/master/inspectionItemsList" },
      {
        moduleAccessId: 12, label: "Users", to: "/master/usersList"
      },
      { moduleAccessId: 13, label: "Holiday List", to: "/master/holiday" },
      { moduleAccessId: 17, label: "Job Description", to: "/master/jobDescription" },
    ],
  },
  {
    label: "Business Administration",
    moduleAccessId: 2,
    children: [
      { moduleAccessId: 21, label: "Emp Management", to: "/master/employeeMaster" },
      {
        moduleAccessId: 22,
        label: "Competency Matrix",
        children: [
          { moduleAccessId: 221, label: "Mechanical", to: "/camMechanicalList" },
          { moduleAccessId: 222, label: "Electrical", to: "/camElectricalList" },
          { moduleAccessId: 223, label: "Report", to: "/camreport" },
        ],
      },
      {
        moduleAccessId: 23,
        label: "Client Management",
        to: "/master/clientsList",
      },
      { moduleAccessId: 24, label: "Zone Management", to: "#" },
      { moduleAccessId: 25, label: "Target", to: "#" },
      { moduleAccessId: 26, label: "Governors", to: "#" },
    ],
  },
  {
    label: "Business Development",
    moduleAccessId: 3,
    children: [
      {
        moduleAccessId: 31,
        label: "Business Acquisition",
        children: [
          { moduleAccessId: 311, label: "Enquiries", to: "/enquiryList" },
          { moduleAccessId: 312, label: "Quotation", to: "/quotationList" },
          { moduleAccessId: 313, label: "PO Acceptance", to: "/poAcceptanceList" },
        ],
      },
      {
        moduleAccessId: 32,
        label: "Business Performance & Records",
        children: [
          {
            moduleAccessId: 321,
            label: "Records",
            children: [
              { moduleAccessId: 3211, label: "Contract Review Register", to: "#" },
              { moduleAccessId: 3212, label: "Order Booking Register", to: "#" },
              { moduleAccessId: 3213, label: "Lost Order Register", to: "#" },
              { moduleAccessId: 3214, label: "Customer Feedback Register (BD)", to: "#" },
            ],
          },
          {
            moduleAccessId: 322,
            label: "Reports & Analytics",
            children: [
              { moduleAccessId: 3221, label: "Enquiry Register", to: "/enquiryRegisterReport" },
              { moduleAccessId: 3222, label: "Quotation Conversion Ratio", to: "/quotationRatioReport" },
              { moduleAccessId: 3223, label: "Revenue Forecast", to: "#" },
            ],
          },
        ],
      },
      {
        moduleAccessId: 33,
        label: "Sales Analytics",
        children: [
          {
            moduleAccessId: 331,
            label: "Sales KPIs",
            children: [
              { moduleAccessId: 3311, label: "Business Development KPIs", to: "#" },
            ],
          },
        ],
      },
    ],
  },
  {
    label: "Inspection Operations",
    moduleAccessId: 4,
    children: [
      {
        moduleAccessId: 41,
        label: "Client & Jobs",
        children: [
          {
            moduleAccessId: 411,
            label: "Job Execution",
            children: [
              { moduleAccessId: 4111, label: "Create Job", to: "/jobRegisterList" },
              { moduleAccessId: 4112, label: "Assign Job", to: "/inspectionTaskList" },
              { moduleAccessId: 4113, label: "General IR", to: "/generalIRList" },
            ],
          },
          {
            moduleAccessId: 412,
            label: "Inspector Deployment",
            children: [
              { moduleAccessId: 4121, label: "Inspector Schedule", to: "/inspectorscheduleReport" },
              { moduleAccessId: 4122, label: "Inspection Call Register", to: "/inspectionCallRegisterReport" },
              { moduleAccessId: 4123, label: "Witness Audit Tracking", to: "#" },
            ],
          },
          {
            moduleAccessId: 413,
            label: "Inspection Call",
            children: [
              { moduleAccessId: 4131, label: "Call Allocation", to: "#" },
              { moduleAccessId: 4132, label: "Inspection Log", to: "#" },
            ],
          },
          { moduleAccessId: 414, label: "Ops Performance", to: "#" },
        ],
      },
    ],
  },
  {
    label: "QHSE Excellence",
    moduleAccessId: 5,
    children: [
      {
        moduleAccessId: 51,
        label: "QHSE Governance",
        children: [
          { moduleAccessId: 511, label: "Compliance & Monitoring", to: "#" },
          { moduleAccessId: 512, label: "Quality KPIs", to: "#" },
        ],
      },
      {
        moduleAccessId: 52,
        label: "Competence & Capability",
        children: [
          { moduleAccessId: 521, label: "Competence", to: "#" },
          { moduleAccessId: 522, label: "Competence Approvals", to: "#" },
        ],
      },
      {
        moduleAccessId: 53,
        label: "Safety & Risk Control",
        children: [
          { moduleAccessId: 531, label: "Safety", to: "#" },
          { moduleAccessId: 532, label: "Risk Management", to: "#" },
        ],
      },
      {
        moduleAccessId: 54,
        label: "Assurance & Compliance",
        children: [
          { moduleAccessId: 541, label: "Audit Scheduling", to: "#" },
          { moduleAccessId: 542, label: "Certification Tracking", to: "#" },
        ],
      },
      {
        moduleAccessId: 55,
        label: "Customer Assurance",
        children: [
          { moduleAccessId: 551, label: "Customer Interaction", to: "#" },
        ],
      },
    ],
  },
  {
    label: "Talent Acquisition & Development",
    moduleAccessId: 6,
    children: [
      {
        moduleAccessId: 61,
        label: "Talent Acquisition",
        children: [
          { moduleAccessId: 611, label: "Requirements", to: "/talent-acquisition/requirements", },
          { moduleAccessId: 612, label: "Candidates", to: "/talent-acquisition/candidates" },
          { moduleAccessId: 613, label: "Pipeline", to: "/talent-acquisition/pipeline" },
          { moduleAccessId: 614, label: "Interview Sched", to: "/talent-acquisition/interview-schedules" },
          { moduleAccessId: 615, label: "Offer & Joining", to: "/talent-acquisition/offers" },
          { moduleAccessId: 616, label: "Masters", to: "/talent-acquisition/masters", },
        ],
      },
      { moduleAccessId: 62, label: "Training", to: "#" },
      {
        moduleAccessId: 63,
        label: "Information Compliance",
        children: [
          { moduleAccessId: 631, label: "Document Control", to: "#" },
          { moduleAccessId: 632, label: "Record Retention", to: "#" },
          { moduleAccessId: 633, label: "Audit Trail", to: "#" },
        ],
      },
      { moduleAccessId: 64, label: "Knowledge Center", to: "#" },
      { moduleAccessId: 65, label: "Competency Authorization", to: "#" },
    ],
  },
  {
    label: "Audit & Compliance",
    moduleAccessId: 7,

    children: [
      { moduleAccessId: 71, label: "Internal Audit Management", to: "#" },
      { moduleAccessId: 72, label: "Management Review Meetings", to: "#" },
      { moduleAccessId: 73, label: "Continuous Improvement", to: "#" },
    ],
  },
  {
    label: "Human Capital Management",
    moduleAccessId: 8,
    children: [
      {
        moduleAccessId: 81,
        label: "HR Management",
        children: [
          { moduleAccessId: 811, label: "Employee Lifecycle", to: "#" },
          { moduleAccessId: 812, label: "Policies & Compliance", to: "#" },
          { moduleAccessId: 813, label: "Performance & Appraisal", to: "#" },
          { moduleAccessId: 814, label: "Employee Records", to: "#" },
        ],
      },
      {
        moduleAccessId: 82,
        label: "Time & Productivity",
        children: [
          {
            moduleAccessId: 821,
            label: "Attendance",
            children: [
              { moduleAccessId: 8211, label: "Attendance Report", to: "/attendance" },
              { moduleAccessId: 8212, label: "Attendance Regularization", to: "/attendanceRegularizationList" },
            ],
          },
          { moduleAccessId: 822, label: "Resource Utilisation", to: "#" },
          { moduleAccessId: 823,
            label: "Leave Management",
            children: [
              { moduleAccessId: 8231, label: "Leave Request", to: "/leave/apply" },
              { moduleAccessId: 8232, label: "Leave Report", to: "/leave/report" },
              { moduleAccessId: 8233, label: "Leave Balance Report", to: "/leave/balanceReport" },
              { moduleAccessId: 8234, label: "Leave Regulization", to: "/leave/leaveRegularization" },
            ],
          },
          { moduleAccessId: 824, label: "Employee Productivity", to: "#" },
          { moduleAccessId: 825, label: "Timesheet Data", to: "#" },
          { moduleAccessId: 826, label: "Profitability Metrics", to: "#" },
        ],
      },
    ],
  },
  {
    label: "Financial Management",
    moduleAccessId: 9,
    children: [
      {
        moduleAccessId: 91,
        label: "Accounts & Finance",
        children: [
          { moduleAccessId: 911, label: "Core Accounting", to: "#" },
          { moduleAccessId: 912, label: "Billing & Invoicing", to: "#" },
          { moduleAccessId: 913, label: "Payroll & Compliance", to: "#" },
        ],
      },
    ],
  },
  {
    label: "Business Control Centre",
    moduleAccessId: 10,
    children: [
      {
        moduleAccessId: 101,
        label: "Business Intelligence",
        children: [
          { moduleAccessId: 1011, label: "Admin MIS", to: "#" },
          { moduleAccessId: 1012, label: "BD/SM MIS", to: "#" },
          { moduleAccessId: 1013, label: "Operations MIS", to: "#" },
          { moduleAccessId: 1014, label: "QHSE MIS", to: "#" },
          { moduleAccessId: 1015, label: "Finance MIS", to: "#" },
          { moduleAccessId: 1016, label: "Customer Specific MIS", to: "#" },
          { moduleAccessId: 1017, label: "Expense MIS", to: "/timesheetDataReport" },
          { moduleAccessId: 1018, label: "Training MIS", to: "#" },
          { moduleAccessId: 1019, label: "Inspection MIS", to: "#" },
          { moduleAccessId: 10110, label: "HR MIS", to: "#" },
          { moduleAccessId: 10111, label: "Accounts Receivable MIS", to: "#" },
        ],
      },
      {
        moduleAccessId: 102,
        label: "Performance Dashboards",
        children: [
          { moduleAccessId: 1021, label: "Operations Dashboard", to: "#" },
          { moduleAccessId: 1022, label: "BD/SM Dashboard", to: "#" },
          { moduleAccessId: 1023, label: "Inspection Dashboard", to: "#" },
          { moduleAccessId: 1024, label: "Timesheet Dashboard", to: "#" },
          { moduleAccessId: 1025, label: "Expense Dashboard", to: "#" },
          { moduleAccessId: 1026, label: "KPI Dashboard", to: "#" },
          { moduleAccessId: 1027, label: "QHSE Dashboard", to: "#" },
          { moduleAccessId: 1028, label: "Feedback & Training Dashboard", to: "#" },
          { moduleAccessId: 1029, label: "Knowledge & Profile Dashboard", to: "#" },
          { moduleAccessId: 10210, label: "Financial Dashboard", to: "#" },
          { moduleAccessId: 10211, label: "Profitability Dashboard", to: "#" },
        ],
      },
      {
        moduleAccessId: 103,
        label: "Business Support",
        children: [
          { moduleAccessId: 1031, label: "Development", to: "#" },
          { moduleAccessId: 1032, label: "HR Support", to: "#" },
          { moduleAccessId: 1033, label: "System Feedback", to: "#" },
          { moduleAccessId: 1034, label: "HR / Training KPIs", to: "#" },
        ],
      },
      {
        moduleAccessId: 104,
        label: "IMS Document Library",
        children: [
          { moduleAccessId: 1041, label: "Company Policies", to: "#" },
          { moduleAccessId: 1042, label: "Quality Manuals", to: "#" },
          { moduleAccessId: 1043, label: "Procedures", to: "#" },
          { moduleAccessId: 1044, label: "Work Instructions", to: "#" },
          { moduleAccessId: 1045, label: "Forms & Formats", to: "#" },
          { moduleAccessId: 1046, label: "Checklists", to: "#" },
          { moduleAccessId: 1047, label: "Codes & Standards", to: "#" },
          { moduleAccessId: 1048, label: "Corporate KPIs", to: "#" },  
        ],
      },
    ],
  },
];

// mobile accordion nav — tap to expand, tap again to collapse
function RecursiveMobileItem({ item, level, location, clearNav, onClose, openSections, toggleSection }) {
  const hasChildren = item.children && getVisibleChildren(item).length > 0;
  const isActive = isItemActive(item, location.pathname);
  const expanded = openSections[`${level}-${item.label}`];

  if (hasChildren) {
    return (
      <div>
        <button
          onClick={() => toggleSection(`${level}-${item.label}`)}
          className="flex items-center justify-between w-full px-4 py-3 rounded-xl text-base text-gray-700 hover:bg-gradient-to-r from-gray-50 to-blue-50 transition-all duration-200 ease-in-out"
        >
          <span className="flex items-center gap-3">        
            {item.label}
          </span>
          <MdKeyboardArrowDown className={`h-5 w-5 transition-transform duration-300 ease-in-out ${expanded ? "rotate-180" : ""}`} />
        </button>
        {expanded && (
          <div className="ml-4 mt-1 space-y-1 animate-fade-in">
            {getVisibleChildren(item).map((child, idx) => (
              <RecursiveMobileItem
                key={idx}
                item={child}
                level={level + 1}
                location={location}
                clearNav={clearNav}
                onClose={onClose}
                openSections={openSections}
                toggleSection={toggleSection}
              />
            ))}
          </div>
        )}
      </div>
    );
  }

  return (
    <Link
      to={item.to || "#"}
      rel="opener"
      onClick={(e) => {
        if (e.ctrlKey || e.metaKey) {
          e.preventDefault();
          window.open(item.to.startsWith("#") ? item.to : "/#" + item.to, "_blank");
          return;
        }
        if (item.to && item.to !== "#") {
          clearNav(item.to);
          onClose();
        } else {
          e.preventDefault();
        }
      }}

      className={`flex items-center gap-3 px-4 py-3 rounded-xl text-base transition-all duration-200 ease-in-out hover:translate-x-1
        ${location.pathname === item.to
          ? "bg-gradient-to-r from-blue-50 to-indigo-50 text-blue-800 font-semibold"
          : "text-gray-700 hover:bg-gradient-to-r from-gray-50 to-blue-50"
        }`}
    >  
      {item.label}
    </Link>
  );
}

// avatar button in the top-right that opens quick profile actions + logout
function ProfileDropdown({ username, onLogout, menuItems, onNavigate, onOpenAttendance, hasAttendanceAccess, onCloseAllDropdowns  }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const initial = username ? username.charAt(0).toUpperCase() : "U";

  return (
    <div ref={ref} className="relative flex-shrink-0">
      <button
        onClick={() => { 
          onCloseAllDropdowns?.(); 
          setOpen((v) => !v);
        }}
        className="h-9 w-9 rounded-full bg-gradient-to-br from-white/35 to-white/15 border border-white/45 flex items-center justify-center text-white font-bold text-sm hover:scale-110 hover:shadow-xl transition-all duration-300"
        title="Profile"
      >
        {initial}
      </button>

      {open && (
        <div className="absolute top-full right-0 mt-3 w-60 bg-white/95 backdrop-blur-xl rounded-xl shadow-xl border border-white/50 z-[999] py-2 animate-dropdown overflow-hidden">
          {hasAttendanceAccess && (
            <button
              onClick={() => {
                setOpen(false);
                onOpenAttendance?.();
              }}
              className="flex items-center gap-2.5 w-full px-4 py-3 text-sm text-slate-700 hover:bg-slate-50/90 transition-all duration-300 rounded-lg text-left"
            >
              <LibraryAddCheckIcon fontSize="small" className="text-blue-600" />
              Mark Attendance
            </button>
          )}

          {menuItems.map((item) => (
            <button
              key={item.label}
              onClick={() => {
                setOpen(false);
                item.to && onNavigate(item.to);
              }}
              disabled={!item.to}
              className={`flex items-center gap-2.5 w-full px-4 py-3 text-sm transition-all duration-300 rounded-lg ${
                item.to
                  ? "text-slate-700 hover:bg-slate-50/90"
                  : "text-slate-400 cursor-not-allowed"
              }`}
            >
              <item.icon className="h-4 w-4" />
              {item.label}
            </button>
          ))}
          {menuItems.length > 0 && <div className="mx-3 my-1 border-t border-slate-200" />}
          <button
            onClick={() => { setOpen(false); onLogout(); }}
            className="flex items-center gap-2.5 w-full px-4 py-3 text-sm text-red-600 hover:bg-red-50/80 transition-all duration-300 rounded-lg "
          >
            <MdLogout className="h-4 w-4" />
            Log Out
          </button>
        </div>
      )}
    </div>
  );
}

// full-screen slide-in drawer for mobile nav
function MobileMenu({ open, onClose, location, clearNav, username, onLogout }) {
  const [openSections, setOpenSections] = useState({});
  const toggleSection = (key) => setOpenSections((p) => ({ ...p, [key]: !p[key] }));

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white w-80 h-full overflow-y-auto shadow-2xl z-10 flex flex-col animate-slide-in-left">
        {/* Header */}
        <div className="bg-gradient-to-r from-[#0e1b3d] to-[#1c2d52] px-6 py-6 flex items-center justify-between shadow-lg">
          <div className="flex items-center gap-3">
            <div className="h-12 w-12 rounded-full bg-white/20 flex items-center justify-center">
              <MdWork className="h-7 w-7 text-white" />
            </div>
            <div>
              <p className="text-white font-bold text-lg">DYC Global</p>
              <p className="text-white/70 text-xs">{username}</p>
            </div>
          </div>
        </div>

        {/* Nav items */}
        <nav className="p-4 space-y-2 flex-1">
          {mainMenuItems
            .filter((item) => !item.moduleAccessId || hasAccessToModule(item.moduleAccessId))
            .map((item, idx) => (
              <RecursiveMobileItem
                key={idx}
                item={item}
                level={0}
                location={location}
                clearNav={clearNav}
                onClose={onClose}
                openSections={openSections}
                toggleSection={toggleSection}
              />
            ))}
        </nav>

        {/* Logout */}
        <div className="border-t p-4 bg-gradient-to-r from-gray-50 to-blue-50">
          <button
            onClick={() => { onClose(); onLogout(); }}
            className="flex items-center gap-3 w-full px-4 py-3 text-base text-red-600 hover:bg-red-50 rounded-xl transition-all duration-200 shadow-sm"
          >
            <MdLogout className="h-6 w-6" />
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
}

// main navbar — two-layer header: logo/profile on top, scrollable menu below
export default function Sidebar({
  isSidebarOpen, setSidebarOpen, isMobile,
  username, notificationsNo, onNotificationClick, onLogout, isHome,
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname;
  const [mobileOpen, setMobileOpen] = useState(false);
  const [key, setKey] = useState(0); // To force re-render to close all dropdowns
  const [activeMenuLabel, setActiveMenuLabel] = useState(null);
  const [attendanceModalOpen, setAttendanceModalOpen] = useState(false);
  const headerRef = useRef(null);

  const [searchExpanded, setSearchExpanded] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const employeeId = localStorage.getItem("employeeId");
  const searchRef = useRef(null);
  const searchInputRef = useRef(null);
  const searchResultsRef = useRef([]);
  const listContainerRef = useRef(null);
  const profileMenuItems = [
      {
      label: "Profile",
      to: employeeId ? `/master/employeeMasterPrint/${employeeId}` : null,
      icon: MdPersonOutline,
    },
    {
      label: "Profile Photo",
      to: employeeId ? `/master/employeeMasterPrint/${employeeId}` : null,
      icon: MdOutlineCameraAlt,
    },
    {
      label: "Calendar",
      to: employeeId ? `/master/employeeCalendar/${employeeId}` : null,
      icon: MdOutlineCalendarMonth,
    },
  ];

  useEffect(() => {
    if (selectedIndex >= 0 && listContainerRef.current) {
      const activeEl = listContainerRef.current.querySelector(`[data-index="${selectedIndex}"]`);
      if (activeEl) {
        activeEl.scrollIntoView({
          block: "nearest",
          behavior: "smooth"
        });
      }
    }
  }, [selectedIndex]);

  // Get all searchable pages dynamically from mainMenuItems and filter by permissions
  const getSearchablePages = useCallback(() => {
    const list = [
      { label: "Home", to: "/", moduleAccessId: null, fullLabel: "Home" },
      { label: "About Us", to: "/about", moduleAccessId: null, fullLabel: "About Us" },
      { label: "Dashboard", to: "/dashboard", moduleAccessId: 100, fullLabel: "Dashboard" }
    ];

    const traverse = (items, parentLabel = "") => {
      items.forEach((item) => {
        const currentLabel = parentLabel ? `${parentLabel} > ${item.label}` : item.label;
        if (item.to && item.to !== "#") {
          list.push({
            label: item.label,
            to: item.to,
            moduleAccessId: item.moduleAccessId,
            fullLabel: currentLabel
          });
        }
        if (item.children) {
          traverse(item.children, currentLabel);
        }
      });
    };

    traverse(mainMenuItems);
    return list.filter(item => !item.moduleAccessId || hasAccessToModule(item.moduleAccessId));
  }, []);

  useEffect(() => {
    if (!searchExpanded) return;

    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setSearchExpanded(false);
        setSearchQuery("");
      }
    };

    const handleScroll = (event) => {
      // Don't close if the user is scrolling inside the search results dropdown
      if (searchRef.current && searchRef.current.contains(event.target)) return;
      setSearchExpanded(false);
      setSearchQuery("");
      setSelectedIndex(-1);
    };

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setSearchExpanded(false);
        setSearchQuery("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("scroll", handleScroll, true); // Capture phase to catch scroll on any container
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("scroll", handleScroll, true);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [searchExpanded]);

  const trackViewportRef = useRef(null);
  const trackRef = useRef(null);
  const [trackOffset, setTrackOffset] = useState(0);
  const [maxTrackOffset, setMaxTrackOffset] = useState(0);
  const STEP = 220;

  const recalcTrackBounds = useCallback(() => {
    const viewport = trackViewportRef.current;
    const track = trackRef.current;
    if (!viewport || !track) return;
    const max = Math.max(0, track.scrollWidth - viewport.clientWidth);
    setMaxTrackOffset(max);
    setTrackOffset((prev) => Math.min(prev, max));
  }, []);

  useLayoutEffect(() => {
    recalcTrackBounds();
    const ro = new ResizeObserver(recalcTrackBounds);
    if (trackViewportRef.current) ro.observe(trackViewportRef.current);
    if (trackRef.current) ro.observe(trackRef.current);
    window.addEventListener("resize", recalcTrackBounds);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", recalcTrackBounds);
    };
  }, [recalcTrackBounds, key]);

  // toggle: one click expands to show all items, next click collapses back
  const toggleTrack = () => {
    if (trackOffset < maxTrackOffset) {
      setTrackOffset(maxTrackOffset); // jump to end (fully expanded)
    } else {
      setTrackOffset(0); // collapse back to start
    }
  };

  // drag-to-scroll on the nav track
  const isDragging = useRef(false);
  const dragStartX = useRef(0);
  const dragStartOffset = useRef(0);

  const onTrackMouseDown = (e) => {
    isDragging.current = true;
    dragStartX.current = e.clientX;
    dragStartOffset.current = trackOffset;
    document.body.style.userSelect = "none";
  };

  const onTrackMouseMove = useCallback((e) => {
    if (!isDragging.current) return;
    const delta = dragStartX.current - e.clientX;
    const next = Math.min(Math.max(dragStartOffset.current + delta, 0), maxTrackOffset);
    setTrackOffset(next);
  }, [maxTrackOffset]);

  const onTrackMouseUp = useCallback(() => {
    isDragging.current = false;
    document.body.style.userSelect = "";
  }, []);

  useEffect(() => {
    document.addEventListener("mousemove", onTrackMouseMove);
    document.addEventListener("mouseup", onTrackMouseUp);
    return () => {
      document.removeEventListener("mousemove", onTrackMouseMove);
      document.removeEventListener("mouseup", onTrackMouseUp);
    };
  }, [onTrackMouseMove, onTrackMouseUp]);

  const previouspath = sessionStorage.getItem("currentPath");

  const clearNav = (to) => {
    const shouldConfirm = ["/editdatasheet", "/editInward"].some((r) => pathname.startsWith(r));
    const go = () => {
      if (to !== previouspath) {
        ["searchBy","searchKey","searched","currentPath",
         "ListPageCount","ListRowsPerPage","fromDate","toDate","selectEmployee"]
          .forEach((k) => sessionStorage.removeItem(k));
      }
      navigate(to);
    };
    if (shouldConfirm) { if (window.confirm("Are you sure you want to quit?")) go(); }
    else go();
  };

  const closeAllDropdowns = () => {
    setActiveMenuLabel(null);
    setKey(k => k + 1); // Force re-render to reset all open dropdown states
  };

  // Compute search results at render time so keyboard handler (via ref) always has fresh list
  const _searchQ = searchExpanded ? searchQuery.trim().toLowerCase() : "";
  const currentSearchResults = _searchQ
    ? getSearchablePages().filter(
        (p) => p.label.toLowerCase().includes(_searchQ) || p.fullLabel.toLowerCase().includes(_searchQ)
      ).slice(0, 8)
    : [];
  searchResultsRef.current = currentSearchResults;


  return (
    <>
      {/* Add custom animations to global styles (embedded) */}
      <style>{`
        @keyframes dropdown {
          0% {
            opacity: 0;
            transform: translateY(-4px) scale(0.99);
          }
          100% {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
        .animate-dropdown {
          animation: dropdown 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
          transform-origin: top left;
        }
        @keyframes slideInLeft {
          0% {
            opacity: 0;
            transform: translateX(-100%);
          }
          100% {
            opacity: 1;
            transform: translateX(0);
          }
        }
        .animate-slide-in-left {
          animation: slideInLeft 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
        }
        @keyframes fadeIn {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }
        .animate-fade-in {
          animation: fadeIn 0.25s ease-out;
        }
        @keyframes searchExpand {
          0% {
            width: 36px;
            opacity: 0.7;
          }
          100% {
            opacity: 1;
          }
        }
        .search-bar-expanded {
          animation: searchExpand 0.28s cubic-bezier(0.34, 1.56, 0.64, 1);
        }
        @keyframes searchResults {
          0% {
            opacity: 0;
            transform: translateY(-8px) scale(0.97);
          }
          100% {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
        .animate-search-results {
          animation: searchResults 0.22s cubic-bezier(0.34, 1.56, 0.64, 1);
          transform-origin: top right;
        }
        @keyframes floatingPanel {
          0% {
            opacity: 0;
            transform: translate(-50%, -8px);
          }
          100% {
            opacity: 1;
            transform: translate(-50%, 0);
          }
        }
        .animate-floating-panel {
          animation: floatingPanel 0.18s ease-out;
        }
        @keyframes rowFade {
          0% {
            opacity: 0;
            transform: translateY(-4px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-row-fade {
          animation: rowFade 0.16s ease-out;
        }
      `}</style>

      {/* ── Top Navbar ─────────────────────────────────────────────────── */}
      <header ref={headerRef} className={`w-full z-[1000] transition-all duration-300 ${
        isHome
          ? "bg-black/20 backdrop-blur-md absolute top-0 left-0 right-0"
          : "bg-gradient-to-r from-[#0e1b3d] via-[#1c2d52] to-[#0e1b3d] relative flex-shrink-0 shadow-2xl"
      }`}>

        {/* First layer: Logo + Search + Home/About + Profile */}
        <div className="flex items-center h-14 px-4 lg:px-6 gap-3">

          {/* Brand Logo Area */}
          <div className="flex items-center gap-3 flex-shrink-0">
            <img src={logo} alt="DYC Global" className="h-11 object-contain" />
          </div>

          {/* Hamburger — mobile only */}
          <button
            className="text-white p-2 rounded-xl hover:bg-white/20 transition-all duration-300 lg:hidden flex-shrink-0"
            onClick={() => setMobileOpen(true)}
          >
            <MdMenu className="h-6 w-6" />
          </button>

          {/* Spacer */}
          <div className="flex-1"></div>

          {/* animated search bar, expands leftward */}
          <div ref={searchRef} className="relative w-9 h-9 flex-shrink-0">
            <div
              className={`absolute right-0 top-0 flex items-center overflow-hidden border transition-all duration-300 ease-in-out h-9
                ${
                  searchExpanded
                    ? "w-44 sm:w-56 lg:w-72 rounded-full bg-white/15 border-white/40 backdrop-blur-sm search-bar-expanded"
                    : "w-9 rounded-full bg-white/10 border-white/20 hover:bg-white/20 hover:border-white/35"
                }`}
            >
              {/* Input — handles ↑ ↓ Enter keyboard nav */}
              {searchExpanded && (
                <>
                  <input
                    ref={searchInputRef}
                    type="text"
                    value={searchQuery}
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                      setSelectedIndex(-1);
                    }}
                    onKeyDown={(e) => {
                      const res = searchResultsRef.current;
                      if (e.key === "ArrowDown") {
                        e.preventDefault();
                        setSelectedIndex((i) => Math.min(i + 1, res.length - 1));
                      } else if (e.key === "ArrowUp") {
                        e.preventDefault();
                        setSelectedIndex((i) => Math.max(i - 1, -1));
                      } else if (e.key === "Enter" && res.length > 0) {
                        e.preventDefault();
                        const target = res[selectedIndex >= 0 ? selectedIndex : 0];
                        if (target) {
                          clearNav(target.to);
                          setSearchQuery("");
                          setSelectedIndex(-1);
                        }
                      }
                    }}
                    placeholder="Search pages…"
                    className="flex-1 bg-transparent text-white placeholder-white/50 text-[13px] outline-none pl-4 pr-2 py-0 min-w-0"
                  />
                  {searchQuery && (
                    <button
                      onClick={() => { setSearchQuery(""); setSelectedIndex(-1); }}
                      className="flex-shrink-0 mr-1 text-white/60 hover:text-white transition-colors duration-200"
                    >
                      <MdClose className="h-4 w-4" />
                    </button>
                  )}
                </>
              )}

              {/* Search Icon / toggle button */}
              <button
                onClick={() => {
                  if (searchExpanded) {
                    setSearchExpanded(false);
                    setSearchQuery("");
                    setSelectedIndex(-1);
                  } else {
                    setSearchExpanded(true);
                    setTimeout(() => searchInputRef.current?.focus(), 50);
                  }
                }}
                className="flex-shrink-0 h-9 w-9 flex items-center justify-center text-white/90 hover:text-white transition-colors duration-200 rounded-full"
                aria-label="Search pages"
              >
                <MdSearch className="h-[18px] w-[18px]" />
              </button>
            </div>

            {/* Search Results Dropdown — width matches the search bar expanded state */}
            {searchExpanded && searchQuery.trim() && (
              <div className="absolute right-0 top-full mt-2 w-44 sm:w-56 lg:w-72 bg-white/95 backdrop-blur-xl rounded-2xl shadow-2xl border border-white/40 z-[1000] overflow-hidden animate-search-results">
                {currentSearchResults.length > 0 ? (
                  <ul ref={listContainerRef} className="py-1.5 max-h-72 overflow-y-auto">
                    {currentSearchResults.map((page, idx) => (
                      <li key={idx} data-index={idx}>
                        <Link
                          to={page.to}
                          rel="opener"
                          onClick={(e) => {
                            if (e.ctrlKey || e.metaKey) {
                              e.preventDefault();
                              window.open(page.to.startsWith("#") ? page.to : "/#" + page.to, "_blank");
                              return;
                            }
                            clearNav(page.to);
                            setSearchQuery("");
                            setSelectedIndex(-1);
                          }}
              
                          className={`flex flex-col px-4 py-1.5 transition-colors duration-150 group ${
                            idx === selectedIndex
                              ? "bg-gray-300"
                              : "hover:bg-gray-200"
                          }`}
                        >
                          <span className={`text-[13px] font-semibold leading-tight transition-colors duration-150 ${
                            idx === selectedIndex ? "text-gray-900" : "text-gray-800 group-hover:text-gray-900"
                          }`}>
                            {page.label}
                          </span>
                          {page.fullLabel !== page.label && (
                            <span className="text-[11px] text-gray-400 mt-0.5 leading-tight truncate">
                              {page.fullLabel}
                            </span>
                          )}
                        </Link>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <div className="flex flex-col items-center justify-center py-8 px-4">
                    <MdSearch className="h-8 w-8 text-gray-300 mb-2" />
                    <p className="text-[13px] text-gray-400 text-center">No pages found for <span className="font-semibold text-gray-500">&ldquo;{searchQuery}&rdquo;</span></p>
                  </div>
                )}
              </div>
            )}
          </div>
          {/*  End Search Bar  */}

          {/* Home and About Us buttons */}
          <div className="hidden lg:flex items-center gap-2">
            <Link
              to="/"
              rel="opener"
              onClick={(e) => {
                if (e.ctrlKey || e.metaKey) {
                  e.preventDefault();
                  window.open("/#/", "_blank");
                }
              }}

              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-xl transition-all duration-300 text-[13px] font-medium border ${
                pathname === "/"
                  ? "text-white border-white/25 bg-white/10"
                  : "text-white/90 hover:bg-white/20 hover:text-white border-transparent hover:border-white/20"
              }`}
            >
              <MdHome className="h-4 w-4" />
              Home
            </Link>
            <Link
              to="/about"
              rel="opener"
              onClick={(e) => {
                if (e.ctrlKey || e.metaKey) {
                  e.preventDefault();
                  window.open("/#/about", "_blank");
                }
              }}

              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-xl transition-all duration-300 text-[13px] font-medium border ${
                pathname === "/about"
                  ? "text-white border-white/25 bg-white/10"
                  : "text-white/90 hover:bg-white/20 hover:text-white border-transparent hover:border-white/20"
              }`}
            >
              <MdInfo className="h-4 w-4" />
              About Us
            </Link>
          </div>

          <div className="flex items-center gap-3 flex-shrink-0">
            {onNotificationClick && (
              <Tooltip title="Notifications">
                <button
                  onClick={onNotificationClick}
                  className="relative text-white p-2 rounded-full hover:bg-white/20 transition-all duration-300"
                >
                  <MdNotificationsNone className="h-5 w-5" />
                  {notificationsNo > 0 && (
                    <span className="absolute -top-0.5 -right-0.5 bg-gradient-to-r from-red-500 to-pink-500 text-white text-[9px] font-bold rounded-full h-4 w-4 flex items-center justify-center leading-none shadow-lg">
                      {notificationsNo > 9 ? "9+" : notificationsNo}
                    </span>
                  )}
                </button>
              </Tooltip>
            )}

            {/* Profile avatar — click to show logout */}
            <ProfileDropdown
              username={username}
              onLogout={onLogout}
              menuItems={profileMenuItems}
              onNavigate={clearNav}
              onOpenAttendance={() => setAttendanceModalOpen(true)}
              hasAttendanceAccess={hasAccessToModule(821) || hasAccessToModule(8211)}
              onCloseAllDropdowns={closeAllDropdowns}
            />

            {(hasAccessToModule(821) || hasAccessToModule(8211)) && (
              <MarkAttendanceModal
                open={attendanceModalOpen}
                onClose={() => setAttendanceModalOpen(false)}
                showTrigger={false}
              />
            )}
          </div>
        </div>

        {/* second layer: nav menu — always transparent, blends into header */}
        <div className="flex items-center h-11 px-2 lg:px-3 gap-1">
          <div ref={trackViewportRef} className="hidden lg:block flex-1 h-full overflow-hidden cursor-grab active:cursor-grabbing">
            <nav
              key={key}
              ref={trackRef}
              onMouseDown={onTrackMouseDown}
              className="flex items-stretch gap-1.5 h-full w-max transition-transform duration-300 ease-out select-none"
              style={{ transform: `translateX(-${trackOffset}px)` }}
            >
              <FloatingNav
                items={mainMenuItems}
                location={location}
                clearNav={clearNav}
                headerRef={headerRef}
                activeL1={activeMenuLabel}
                setActiveL1={setActiveMenuLabel}
              />
            </nav>
          </div>

          {/* single toggle button — expands to show all items, click again to collapse */}
          {maxTrackOffset > 0 && (
            <button
              onClick={toggleTrack}
              className="hidden lg:flex flex-shrink-0 items-center justify-center h-7 w-7 rounded-full bg-white/10 text-white hover:bg-white/25 transition-all duration-200"
              aria-label={trackOffset < maxTrackOffset ? "Expand menu" : "Collapse menu"}
            >
              {trackOffset < maxTrackOffset
                ? <MdKeyboardArrowRight className="h-4 w-4" />
                : <MdKeyboardArrowLeft className="h-4 w-4" />
              }
            </button>
          )}
        </div>
      </header>

      {/* ── Mobile drawer ──────────────────────────────────────────────── */}
      <MobileMenu
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
        location={location}
        clearNav={clearNav}
        username={username}
        onLogout={onLogout}
      />
    </>
  );
}